import React from 'react'
import { listProductBy } from '../function/product';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // นำเข้า useNavigate
import ProductCard from '../card/ProductCard';
import LoadingCard from '../card/LoadingCard';
import { Carousel, Row, Col, Button } from "react-bootstrap";
import axios from "axios";
const BestSellers = () => {
    const [loading, setLoading] = useState(false);
    const [products, setProducts] = useState([]);
    const navigate = useNavigate(); // สร้าง navigate object
  
    useEffect(() => {
      loadData();
    }, []);
  
    const loadData = () => {
      setLoading(true);
      listProductBy("sold", "desc", 50)
        .then((res) => {
          setProducts(res.data);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    };
    const [carouselImages, setCarouselImages] = useState([]);
      useEffect(() => {
        const fetchCarouselImages = async () => {
          try {
            const response = await axios.get(process.env.REACT_APP_API + "/admin/getimages-carousel");
            const selectedImages = response.data.filter((image) => image.isSelected); // กรองเฉพาะรูปภาพที่มี isSelected: true
            setCarouselImages(selectedImages);
          } catch (error) {
            console.error("Error fetching carousel images:", error);
          }
        };
    
        fetchCarouselImages();
      }, []);
  
    return (
        <>
        <div className="row mt-5 ">
        <div className="col-md-12">
          <Carousel interval={2000}>
            {carouselImages.map((image) => (
              <Carousel.Item key={image._id}>
                <img className="d-block w-100" src={image.url} alt={image.alt} />
              </Carousel.Item>
            ))}
          </Carousel>
        </div>
      </div>
      <div className="container allproduct-container">
        {loading ? (
          <LoadingCard count={3} />
        ) : (
          <>
            <div className="row">
              {products.slice(0, 8).map((item, index) => (
                <div key={index} className="col-6 col-sm-6 col-md-4 col-lg-3 mb-4">
                  <ProductCard product={item} />
                </div>
              ))}
            </div>
            {products.length > 8 && (
              <div className="text-center">
                <button
                  className="btn"
                  onClick={() => navigate("/shop")} // ใช้ navigate เพื่อไปที่ /shop
                  style={{ backgroundColor: "#FF70A6", color: "#fff" }}
                >
                  ดูเพิ่มเติม
                </button>
              </div>
            )}
          </>
        )}
      </div>
      </>
    );
  };

export default BestSellers
